import { useState } from "react";
import { StatDiscrepancy } from "./box-score-diff";
import Styles from "./DiscrepancyFlag.module.scss";

const WarnIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
    <path d="M12 2 1 21h22L12 2zm0 6a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zm0 10.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" />
  </svg>
);

// Flags batting lines where our box score disagrees with GameChanger's official book — the
// hit-vs-error class of scoring differences. Collapsed to a one-line summary; expands to the list.
export default function DiscrepancyFlag({ discrepancies }: { discrepancies: StatDiscrepancy[] }) {
  const [open, setOpen] = useState(false);
  if (discrepancies.length === 0) return null;

  const n = discrepancies.length;
  return (
    <div className={Styles.flag}>
      <button type="button" className={Styles.header} onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <WarnIcon />
        <span className={Styles.title}>
          {n} stat {n === 1 ? "difference" : "differences"} from GameChanger
        </span>
        <span className={open ? `${Styles.chev} ${Styles.chevOpen}` : Styles.chev} aria-hidden="true">
          ▾
        </span>
      </button>
      {open && (
        <ul className={Styles.list}>
          {discrepancies.map((d) => (
            <li key={`${d.playerId}:${d.stat}`} className={Styles.item}>
              <span className={Styles.player}>{d.playerName}</span>
              <span className={Styles.statTag}>{d.stat}</span>
              <span className={Styles.vals}>
                box score <b>{d.box}</b> · GameChanger <b>{d.gc}</b>
              </span>
            </li>
          ))}
        </ul>
      )}
      <p className={Styles.note}>
        Your box score is computed from GameChanger&apos;s play-by-play stream; GameChanger&apos;s official line can
        differ on judgment plays (e.g. a hit scored with an error on the same play).
      </p>
    </div>
  );
}
